import { Dispatch, SetStateAction, useCallback, useState } from 'react';

import { UploadedFile } from 'types';

type PreviewFiles = UploadedFile[] | undefined;

export type SetPreviewFiles = Dispatch<SetStateAction<PreviewFiles>>;

export type UsePreviewFilesProps = {
  uploadedFilesChanged?: (uploadedFiles: UploadedFile[]) => void;
};

export type UsePreviewFilesReturn = {
  previewFiles: PreviewFiles;
  setPreviewFiles: SetPreviewFiles;
  concatPreviewFiles: SetPreviewFiles;
};

export const usePreviewFiles = (): UsePreviewFilesReturn => {
  const [previewFiles, setPreviewFiles] = useState<UploadedFile[] | undefined>();

  const concatPreviewFiles: Dispatch<SetStateAction<UploadedFile[] | undefined>> = useCallback(
    (files) =>
      setPreviewFiles((previousFiles) => {
        const newFiles = typeof files === 'function' ? files?.(previousFiles) : files;
        if (!newFiles) return previousFiles;
        return [...(previousFiles || []), ...newFiles];
      }),
    []
  );

  return {
    previewFiles,
    setPreviewFiles,
    concatPreviewFiles,
  };
};
